import React from 'react';

const Footer: React.FC = () => {
  return <footer>EZZE Bank &copy; Tanna Ryan 2022</footer>;
};

export default Footer;
